export type FilterOptionType = {
  count: number;
  name: string;
};

export type FacetType = {
  label: string;
  name: string;
  value: Array<FacetValue>;
};
export type FacetValue = {
  count: number;
  id: string;
  text: string;
};

export type FacetQueryType = {
  name: string;
  max?: number;
  filter?: {
    type: string;
    values: any;
  };
  sort?: {
    name: string;
    order: string;
  };
};

export type LocationDefaultsType = {
  distance: string;
  languages: Array<string>;
  locationtypes: Array<string>;
  PublishToLocal: string;
  query: string;
  sort: string;
  specialty: Array<string>;
  page: number;
};

export type ProviderDefaultsType = {
  availability: Array<string>;
  acceptingnewpatients: Array<string>;
  contracted: boolean;
  credentials: Array<string>;
  distance: string;
  facility_services: Array<string>;
  facility_types: Array<string>;
  gender: Array<string>;
  languages: Array<string>;
  locationtypes: Array<string>;
  locationnames: Array<string>;
  onlinescheduling: Array<string>;
  PublishToLocal: string;
  query: string;
  ratings: string;
  sort: string;
  sortfield: Array<string>;
  specscombo: Array<string>;
  page: number;
};

export type ProviderFiltersType = {
  acceptingnewpatients: Array<string>;
  availability: string | Array<string>;
  distance: string;
  gender: Array<string>;
  latitude: number | string;
  location: string;
  longitude: number | string;
  locationnames: Array<string>;
  onlinescheduling: Array<string>;
  sortfield: Array<string>;
  specscombo: Array<string>;
  languages: Array<string>;
  page?: number;
  PublishToLocal: string;
  zip_code?: string;
};

export type LocationFiltersType = {
  distance: string;
  latitude?: number | '';
  location?: string;
  locationname?: string;
  locationtypes: Array<string>;
  longitude?: number | '';
  PublishToLocal: string;
  languages: Array<string>;
  zip_code?: string;
};

export type ProviderFilterOptionsType = {
  acceptingnewpatients: Array<FacetValue>;
  availability: Array<FilterOptionType>;
  distance: string;
  gender: Array<FacetValue>;
  //latitude: number | string;
  //location: string;
  //longitude: number | string;
  locationnames: Array<FacetValue>;
  onlinescheduling: Array<FacetValue>;
  specscombo: Array<FacetValue>;
  languages: Array<FacetValue>;
  PublishToLocal: string;
};

export type LocationFilterOptionsType = {
  distance?: string;
  locationtypes: Array<FacetValue>;
  languages: Array<FacetValue>;
  PublishToLocal?: string;
};

export type NonDefaultFiltersType = {
  [key: string]: string | Object | boolean | Array<string>;
};

export type FilterPanelType = {
  active: boolean;
  icon?: string;
  id: string;
  label?: string;
  name: string;
};

export type LocationFilterPanelsType =
  //"languages"
  'locationtypes';

export type ProviderFilterPanelsType =
  | 'acceptingnewpatients'
  | 'availability'
  | 'specscombo'
  | 'gender'
  | 'languages'
  | 'locationnames'
  | 'sortfield';

export type DataFacet = {
  label: string;
  name: string;
  value: Array<FacetValue>;
};

//Functions from location search / components - can probs condense these once get all inputs typed

export type AddFilterType = (filter: any, item: any, facet: FacetValue) => void;

export type OnQueryInputChangeType = (value: string) => void;

export type RemoveFilterType = (
  filter: any,
  item: any,
  facet?: FacetValue
) => void;

export type ReplaceLocationFiltersType = (
  lat: number,
  lng: number,
  location: string
) => void;

export type ReplaceFilterType = (filter: any, arr: any) => void;

export type ResetFilterToDefaultType = (filter: any) => void;

export type SetActiveFilterPanelType = (id: string) => void;

export type SetControlPanelType = (control: any) => void;

export type ToggleMobileControlsType = (control: any) => void;

export type UpdateFilterType = (
  filter: string,
  item: string,
  facet?: FacetValue
) => void;

export type UpdateQueryType = (str: string) => void;

export type UpdateSortType = (sort: string) => void;

export type SuperSpecialtyItem = {
  value: Array<SuperSpecialty>;
};

export type SuperSpecialty = {
  id: string;
  name: string;
  Name: {
    value: string;
  };
  Icon: {
    value: string;
  };
};

export type Specialty = {
  id: string;
  name: string;
  superspecialty: {
    value: Array<SuperSpecialty>;
  };
  superspecialtyitem: SuperSpecialtyItem;
};
